import React from 'react';

export interface ContainerProps {
  /**
   * Content to be contained
   */
  children: React.ReactNode;
  /**
   * Optional CSS class to add
   */
  className?: string;
  /**
   * Container width size
   */
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  /**
   * Whether to add padding
   */
  padding?: boolean;
}

/**
 * Container component to maintain consistent width and spacing throughout the site
 */
export const Container: React.FC<ContainerProps> = ({
  children,
  className = '',
  size = 'lg',
  padding = true,
  ...props
}) => {
  // Size classes
  const sizeClasses = {
    sm: 'max-w-3xl',
    md: 'max-w-5xl',
    lg: 'max-w-7xl',
    xl: 'max-w-screen-2xl',
    full: 'max-w-full',
  };

  // Combine all classes
  const containerClasses = [
    'mx-auto',
    sizeClasses[size],
    padding ? 'px-4 sm:px-6 lg:px-8' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses} {...props}>
      {children}
    </div>
  );
};

export default Container;